export const parseHyperlink = (text?: string) => {
  if (!text) {
    return null;
  }

  const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
  text = text.replace(regex, (match, title, url) => {
    return `<a href="${url}" target="_blank">${title}</a>`;
  });
  return <div dangerouslySetInnerHTML={{ __html: text }} />;
};
